module.exports = __webpack_public_path__ + "static/media/14_profile_picture.98b0162f.png";